import { getUtm } from "../hooks/useUtmCapture";

function basePayload() {
  const utm = getUtm();
  return {
    page_path: window.location.pathname,
    utm_source: utm.utm_source || "(direct)",
    utm_medium: utm.utm_medium || "(none)",
    utm_campaign: utm.utm_campaign || "(none)",
    utm_content: utm.utm_content || "(none)",
    utm_term: utm.utm_term || "(none)",
  };
}

// Clique em qualquer botão de WhatsApp.
export function trackWhatsApp(waLocation) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "whatsapp_click",
    wa_location: waLocation, // ex.: "lp_armazem_hero"
    ...basePayload(),
  });
}

// Envio de formulário com sucesso.
export function trackLead(formId, data = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "lead_form",
    form_id: formId, // ex.: "lp_armazem"
    ...basePayload(),
    ...data, // campos extras opcionais (service, load...)
  });
}

// Monta o texto do WhatsApp já com a origem (para o time de vendas)
// e retorna o valor codificado para uso direto em `?text=`.
export function buildWhatsAppText(baseMsg) {
  const utm = getUtm();
  const origem = utm.utm_source
    ? ` (origem: ${utm.utm_source}/${utm.utm_campaign || "-"}/${utm.utm_content || "-"})`
    : "";
  return encodeURIComponent(baseMsg + origem);
}
